import React from 'react';
import './WheelBullets.scss';

interface Props {
    numberOfBullets: number;
    active: number;
    onBulletClicked: (index: number) => void;
}

const WheelBullets = ({ numberOfBullets, active = 0, onBulletClicked }: Props) => {
    // console.log('numberOfBullets', active);
    return (
        <div className='wheel-bullets-container'>
            {Array.from(Array(numberOfBullets).keys()).map((item, index) => {
                return <div onClick={() => onBulletClicked(index)} key={item} className='bullet'
                            style={{ backgroundColor: active === item && '#000000' }} />;
            })}
        </div>
    );
};

export default React.memo(WheelBullets);